import { createApp } from 'vue';
import App from './App.vue';

export default class BundleBuilder {
    constructor (el) {
        if (!el) return;

        this.init();
    }

    init () {
        createApp(App)
            .mount('#app-bundle-builder');
    }
}
